const DancerAnimationNames = {
  blink: 'blink',
  idle: 'idle',
  open: 'open',
  close: 'close',
  showing: 'showing',
  static: 'static',
  push: 'push',
  win: 'win',
};

const DancerAnimationDurations = {
  blink: -1,
  idle: -1,
  open: -1.5,
  showing: -1.5,
  static: null,
  push: -1,
  win: -1,
};

class DancerAnimations {
  constructor() {
    this.animations = {};
  }

  setupAnimations(texture) {
    this.texture = texture;
    Object.values(DancerAnimationNames).forEach((name) => {
      this.animations[name] = (delay = 0, loop = false) => {
        return new Promise((resolve) => {
          texture.state.addAnimation(0, name, loop, delay);
          texture.state.addListener({
            complete(entry) {
              resolve(entry);
            },
          });
        });
      };
    });
    this.texture.stateData.setMix('blink', 'push', 0.2);
    this.texture.stateData.setMix('push', 'blink', 0.4);
    this.texture.stateData.setMix('blink', 'close', 0.2);
    this.texture.stateData.setMix('close', 'blink', 0.4);
  }

  startWinAnimation(delay, loop) {
    return this.animations[DancerAnimationNames.win](delay, loop);
  }

  startBlinkAnimation(delay, loop) {
    return this.animations[DancerAnimationNames.blink](delay, loop);
  }

  startPushAnimation() {
    const currentAnimation = this.texture.state.tracks[0]?.animation.name;
    if (currentAnimation !== 'open' && currentAnimation !== 'close') {
      this.texture.state.setAnimation(0, 'push', false);
      this.texture.state.addAnimation(0, 'blink', true, 0);
    }
  }

  startIdleAnimation(delay, loop) {
    return this.animations[DancerAnimationNames.idle](delay, loop);
  }

  startCloseAnimation() {
    this.texture.state.setAnimation(0, 'close', false);
    this.texture.state.addAnimation(0, 'blink', true, 0);
  }

  startOpenAnimation(delay, loop) {
    this.clearTracks();
    return new Promise((res) => {
      if (delay > DancerAnimationDurations.open) {
        return this.animations[DancerAnimationNames.open](delay, loop).then(() => {
          this.startBlinkAnimation(0, true);
          res(true);
        });
      }
      this.clearOpenTrack();
      this.startBlinkAnimation(0, true);
      res(true);
    });
  }

  startStaticAnimation(delay, loop) {
    return this.animations[DancerAnimationNames.static](delay, loop);
  }

  clearOpenTrack() {
    if (this.texture.state.tracks[0]?.animation.name === 'open') {
      this.texture.state.clearTracks();
      this.startBlinkAnimation(0, true);
    }
  }

  clearBlinkTrack() {
    if (this.texture.state.tracks[0]?.animation.name === 'blink') {
      this.texture.state.clearTracks();
    }
  }

  clearTracks() {
    this.texture?.state.clearTracks();
  }

  startShowingAnimation(delay, loop) {
    return this.animations[DancerAnimationNames.showing](delay, loop);
  }
}

export const dancerAnimations = new DancerAnimations();
window.dancerAnimations = dancerAnimations;
